import { Route } from '@angular/router';
import { SplUiNotFoundFeature } from './not-found.feature';

export const splUiNotFoundFeatureRoute = (fallbackPath = '/'): Route => ({
  path: '**',
  component: SplUiNotFoundFeature,
  data: { fallbackPath },
});
